import * as angular from 'angular';
import * as _ from 'lodash';
import template from './shopSummaryDashboard.tpl.html';
import { States } from "../../shared/config/constant.module";
import { StateParams } from "../../common";
import UIUtilityServiceName, { UIUtilityService } from "../../services/utility/uiUtility.service";
import ShopServiceName, { ShopService } from "../../services/shops/shops.service";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import ShopSummaryServiceName, { IShopSummaryService } from '../../services/dashboard/shopSummary.service';
import AuthDataServiceName, { AuthDataService } from "../../services/auth/authData.service";
import { IBtn, IBtnArrayOptions } from './btnarray.interfaces';
import { IInterval, Interval } from '../../directives/interval.factory';
import { usePercentGobsProducedChanged } from '../counts/count.controller';
import { CountsService } from '../../services/counts/counts.service';

let requires = [
  UIUtilityServiceName,
  ShopServiceName,
  LoaderServiceName,
  ShopSummaryServiceName,
  AuthDataServiceName
];

export interface MetricOverInterval {
  metricName: string;
  currentHourMetric: string;
  previousHourMetric: string;
  currentShiftMetric: string;
  shiftMinus1Metric: string;
  shiftMinus2Metric: string;
  last24HoursMetric: string;
  previousProductionDayMetric: string;
}

export class ShopSummaryDashboardController {
  $interval: angular.IIntervalService;
  interval: IInterval;
  $filter: angular.IFilterService;
  $timeout: angular.ITimeoutService;
  plantId: string;
  shopId: string;
  shopName: string;
  plantName: string;
  $state: angular.ui.IStateService;
  loaderService: LoaderService;
  uiUtilityService: UIUtilityService;
  shopSummaryService: IShopSummaryService;
  shopService: ShopService;
  authDataService: AuthDataService;
  countsService: CountsService;
  usePercentGobs: boolean;
  inspectionDeviceLosses: MetricOverInterval[];
  locationLosses: MetricOverInterval[];
  ceDetailLosses: MetricOverInterval[];
  shopPerformance: MetricOverInterval[];
  topDefects: apsViewModels.CavityDetail[];
  $q: angular.IQService;
  private $scope: angular.IScope;
  data: apsViewModels.ShopSummary;
  navigationUrls: IBtnArrayOptions;
  chartDataHash: any = {
    'previousProductionDay': [],
    'currentHour': [],
    'previousHour': [],
    'currentShift': [],
    'shiftMinus1': [],
    'shiftMinus2': []
  };
  barchartOptions: any;
  shiftSelectors: IBtnArrayOptions = {
    buttons: [
      { 'name': 'Current Hour', 'value': 'currentHour', 'selected': true },
      { 'name': 'Previous Hour', 'value': 'previousHour', 'selected': false },
      { 'name': 'Current Shift', 'value': 'currentShift', 'selected': false },
      { 'name': 'Shift - 1', 'value': 'shiftMinus1', 'selected': false },
      { 'name': 'Shift - 2', 'value': 'shiftMinus2', 'selected': false },
      { 'name': 'Prev. Prod. Day', 'value': 'previousProductionDay', 'selected': false }
    ],
    select: (button: IBtn) => {
      this.barchartOptions.series = [];
      this.$timeout(() => {
        try {
          this.barchartOptions.series = [{
            name: "Inspection Equipment",
            data: this.chartDataHash[button.value]
          }];
        } finally {
          console.log('Chart Data Changed');
        }
      }, 250);
    }
  };

  constructor(
    $filter: angular.IFilterService,
    $timeout: angular.ITimeoutService,
    $stateParams: StateParams,
    $interval: angular.IIntervalService,
    shopService: ShopService,
    loaderService: LoaderService,
    countsService: CountsService,
    $scope: angular.IScope,
    uiUtilityService: UIUtilityService,
    $state: angular.ui.IStateService,
    $q: angular.IQService,
    shopSummaryService: IShopSummaryService) {

    this.usePercentGobs = countsService.getUsePercentGobsForPlantId($stateParams.plantId);
    this.$timeout = $timeout;
    this.$filter = $filter;
    this.$interval = $interval;
    this.plantId = $stateParams.plantId;
    this.shopId = $stateParams.shopId;
    this.countsService = countsService;
    this.loaderService = loaderService;
    this.shopService = shopService;
    this.shopName = null;
    this.plantName = null;
    this.$state = $state;
    this.$scope = $scope;
    this.uiUtilityService = uiUtilityService;
    this.$q = $q;
    this.shopSummaryService = shopSummaryService;
    this.barchartOptions = this.getBarChartOptions();
    this.navigationUrls =	{
			buttons: [
				{ 'name': 'Summary', 'value': 'summary', 'selected': true },
				{ 'name': 'Linesheet', 'value': 'linesheet', 'selected': false },
				{ 'name': 'Horizontal Counts', 'value': 'horizontal', 'selected': false },
				{ 'name': 'Vertical Counts','value': 'vertical', 'selected': false },
        { 'name': 'Vertical Counts (v2)', 'value': 'vc2', 'selected': false },
			],
			select: (button: IBtn) => {
				let stateParams = {
					plantId: $stateParams.plantId,
					shopId: $stateParams.shopId,
					userId: $stateParams.userId,
				};
				switch (button.value) {
					case "summary":
            $state.go(States.SHOP_SUMMARY_DASHBOARD, stateParams); 
            break;
					case "linesheet":
            $state.go(States.LINE_SHEET, stateParams); 
            break;
					case "horizontalv2":
            $state.go(States.COUNTS_HORIZONTAL_V2, stateParams); 
            break;
         case "horizontal":
              $state.go(States.COUNTS_HORIZONTAL, stateParams); 
              break;
					case "vertical":
            $state.go(States.COUNTS_VERTICAL, stateParams); 
            break;
          case "vc2":
              $state.go(States.COUNTS_VERTICAL_V2, stateParams); 
              break;
  
				}
			}
		};

    this.$scope.$on('$destroy', () => {
      this.destroyInterval();
    });

    this.createInterval();
    this.updateData();
  }

  usePercentGobsChanged() {
    this.usePercentGobs = !this.usePercentGobs;
    usePercentGobsProducedChanged(this.countsService, this.plantId, this.usePercentGobs);
    this.barchartOptions = this.getBarChartOptions();
    this.mapShopSummaryResults(this.data);
  }

  getBarChartOptions() {
    return {
      chart: {
        type: 'bar',
        animation: false
      },
      title: {
        text: this.usePercentGobs ? 'Percentage of Gobs Produced Rejected' : 'Percentage of Inspected Ware Rejected'
      },
      accessibility: {
        announceNewData: {
          enabled: true
        }
      },
      xAxis: {
        type: 'category',
        labels: {
          style: {
            color: 'black',
            fontSize: '28px'
          }
        }
      },
      yAxis: {
        title: {
          enabled: false
        },
        labels: {
          style: {
            color: 'black',
            fontSize: '28px'
          }
        },
        plotBands: [
          {
            from: 0,
            to: 3,
            color: '#E6F9F2'
          },
          {
            from: 3,
            to: 5,
            color: '#FFFDE6'
          },
          {
            from: 5,
            to: 7,
            color: '#FFF2EA'
          },
          {
            from: 7,
            to: 100,
            color: '#FFEAE8'
          }
        ],
        minTickInterval: 1,
        ceiling: 100,
        min: 0
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          shadow: true,
          dataLabels: {
            enabled: true,
            format: '{point.y:.2f}%',
            inside: false,
            style: {
              color: 'contrast',
              fontSize: '28px',
              fontWeight: 'bold'
            }
          }
        }
      },
      tooltip: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      series: [{
        data: []
      }]
    };
  }

  destroyInterval() {
    this.interval.destroy();
    this.interval = null;
  }

  createInterval() {
    this.interval = new Interval(() => {
      this.updateData();
    }, this.$interval, 1000 * 60 * 5);
    this.interval.start();
  }

  updateData() {
    this.inspectionDeviceLosses = [];
    this.loaderService.setAppLoading(true);

    this.shopService.getShopConfiguration(this.shopId)
      .then(shop => {
        this.shopName = shop.name;
        this.plantName = shop.plantName;
      }).then(() => {
        this.shopSummaryService.getShopSummary(this.shopId)
          .then((shopSummaryResults) => {
            this.data = shopSummaryResults;
            this.mapShopSummaryResults(shopSummaryResults);
            this.loaderService.setAppLoading(false);
          });
      });
  }

  mapShopSummaryResults(shopSummaryResults: apsViewModels.ShopSummary) {
    this.mapInspectionDeviceLosses(shopSummaryResults);
    this.mapLocationLosses(shopSummaryResults);
    this.mapCeDetailLosses(shopSummaryResults);
    this.mapShopPerformance(shopSummaryResults);
    this.mapChartData(shopSummaryResults);
    this.mapTopDefects(shopSummaryResults);

    let button = this.shiftSelectors.buttons.filter((button) => button.selected)[0];
    this.shiftSelectors.select(button);
  }

  mapTopDefects(shopSummaryResults: apsViewModels.ShopSummary) {
    if(shopSummaryResults.topDefects && shopSummaryResults.topDefects.length >= 1){
      this.topDefects = shopSummaryResults.topDefects.slice(0, 5);
    }
  }

  mapChartData(shopSummaryResults: apsViewModels.ShopSummary) {
    Object.keys(this.chartDataHash).forEach((timeframe) => {
      this.mapChartDataForTimeframe(shopSummaryResults, timeframe);
    });
  }

  mapShopPerformance(shopSummaryResults: apsViewModels.ShopSummary) {
    this.getDefaultShopPerformance();
    this.mapShopPerformanceForTimeframe(shopSummaryResults, 'previousProductionDay');
    this.mapShopPerformanceForTimeframe(shopSummaryResults, 'currentHour');
    this.mapShopPerformanceForTimeframe(shopSummaryResults, 'previousHour');
    this.mapShopPerformanceForTimeframe(shopSummaryResults, 'currentShift');
    this.mapShopPerformanceForTimeframe(shopSummaryResults, 'shiftMinus1');
    this.mapShopPerformanceForTimeframe(shopSummaryResults, 'shiftMinus2');
  }

  mapShopPerformanceForTimeframe(shopSummaryResults: apsViewModels.ShopSummary, timeframe: string) {
    let shopSummaryTimeframe: apsViewModels.CountSummary[] = shopSummaryResults[timeframe].countSummaries || [];
    let heItem: apsViewModels.CountSummary = this.getHotEnd(shopSummaryTimeframe);
    let lehrItem: apsViewModels.CountSummary = this.getLehrItem(shopSummaryTimeframe);
    let ceItems: apsViewModels.CountSummary[] = this.getColdEndItems(shopSummaryTimeframe);
    let gobsProduced: number = (heItem && heItem.inspectCount) 
      ? heItem.inspectCount
      : 0;
    let bottlesPerMinute: number = (shopSummaryResults[timeframe] && shopSummaryResults[timeframe].bottlesPerMinute)
      ? shopSummaryResults[timeframe].bottlesPerMinute
      : 0;

    // set bottles per minute
    let bpmIndex = _.findIndex(this.shopPerformance, { metricName: 'Bottles Per Minute' });
    this.shopPerformance[bpmIndex][timeframe + 'Metric'] = bottlesPerMinute.toLocaleString();

    // set gob count count
    let gobCountIndex = _.findIndex(this.shopPerformance, { metricName: 'Gobs Produced' });
    this.shopPerformance[gobCountIndex][timeframe + 'Metric'] = gobsProduced.toLocaleString();

    // set shears percent
    let shearsIndex = _.findIndex(this.shopPerformance, { metricName: 'Shears' });
    this.shopPerformance[shearsIndex][timeframe + 'Metric'] = '100.00%';

    // set lehr in % and lehr out %
    if (lehrItem) {
      let lehrInIndex = _.findIndex(this.shopPerformance, { metricName: 'Lehr In %' });
      this.shopPerformance[lehrInIndex][timeframe + 'Metric'] =
        this.mapNumberToPercent((lehrItem.inspectCount / gobsProduced) * 100.0);

      let lehrOutIndex = _.findIndex(this.shopPerformance, { metricName: 'Lehr Out %' });
      this.shopPerformance[lehrOutIndex][timeframe + 'Metric'] =
        this.mapNumberToPercent(((lehrItem.inspectCount - lehrItem.rejectCount) / gobsProduced) * 100.0);
    }

    // set cold end and pack efficiency
    if (heItem && ceItems && ceItems.length > 0) {
      let countLen = shopSummaryTimeframe.length;
      let lastItem = shopSummaryTimeframe[countLen - 1];
      let bottlesOut = (lastItem.rejectCount && lastItem.rejectCount > 0.0)
        ? lastItem.inspectCount - lastItem.rejectCount
        : lastItem.inspectCount;

      // set packed count
      let packedCountIndex = _.findIndex(this.shopPerformance, { metricName: 'Packed Count' });
      this.shopPerformance[packedCountIndex][timeframe + 'Metric'] = bottlesOut.toLocaleString();

      // set pack Effeciency
      let packEffeciencyIndex = _.findIndex(this.shopPerformance, { metricName: 'Percent Packed' });
      this.shopPerformance[packEffeciencyIndex][timeframe + 'Metric'] = this.mapNumberToPercent((bottlesOut / gobsProduced) * 100.0);
    }
  }

  getDefaultShopPerformance() {
    let performanceTags = ['Bottles Per Minute', 'Gobs Produced', 'Packed Count', 'Shears', 'Lehr In %', 'Lehr Out %', 'Percent Packed'];
    let shopPerformance: MetricOverInterval[] = [];
    _.forEach(performanceTags, (lt) => {
      let metricItem: MetricOverInterval = {
        metricName: lt,
        previousProductionDayMetric: '-',
        last24HoursMetric: '-',
        currentHourMetric: '-',
        previousHourMetric: '-',
        currentShiftMetric: '-',
        shiftMinus1Metric: '-',
        shiftMinus2Metric: '-'
      };
      shopPerformance.push(metricItem);
    });
    this.shopPerformance = shopPerformance;
  }

  mapLocationLosses(shopSummaryResults: apsViewModels.ShopSummary) {
    this.getDefaultLocationLosses();
    this.mapLocationLossesForTimeframe(shopSummaryResults, 'previousProductionDay');
    this.mapLocationLossesForTimeframe(shopSummaryResults, 'currentHour');
    this.mapLocationLossesForTimeframe(shopSummaryResults, 'previousHour');
    this.mapLocationLossesForTimeframe(shopSummaryResults, 'currentShift');
    this.mapLocationLossesForTimeframe(shopSummaryResults, 'shiftMinus1');
    this.mapLocationLossesForTimeframe(shopSummaryResults, 'shiftMinus2');
  }

  mapCeDetailLosses(shopSummaryResults: apsViewModels.ShopSummary) {
    this.getDefaultCeDetailLosses();
    this.mapCeDetailLossesForTimeframe(shopSummaryResults, 'previousProductionDay');
    this.mapCeDetailLossesForTimeframe(shopSummaryResults, 'currentHour');
    this.mapCeDetailLossesForTimeframe(shopSummaryResults, 'previousHour');
    this.mapCeDetailLossesForTimeframe(shopSummaryResults, 'currentShift');
    this.mapCeDetailLossesForTimeframe(shopSummaryResults, 'shiftMinus1');
    this.mapCeDetailLossesForTimeframe(shopSummaryResults, 'shiftMinus2');
  }

  mapLocationLossesForTimeframe(shopSummaryResults: apsViewModels.ShopSummary, timeframe: string) {
    let shopSummaryTimeframe: apsViewModels.CountSummary[] = shopSummaryResults[timeframe].countSummaries || [];
    let heItem: apsViewModels.CountSummary = this.getHotEnd(shopSummaryTimeframe);
    let lehrItem: apsViewModels.CountSummary = this.getLehrItem(shopSummaryTimeframe);
    let ceItems: apsViewModels.CountSummary[] = this.getColdEndItems(shopSummaryTimeframe);

    // set cold end data
    if (heItem && lehrItem && ceItems && ceItems.length > 0) {
      let countLen = shopSummaryTimeframe.length;
      let lastItem = shopSummaryTimeframe[countLen - 1];
      let bottlesOut = (lastItem.rejectCount && lastItem.rejectCount > 0.0)
        ? lastItem.inspectCount - lastItem.rejectCount
        : lastItem.inspectCount;
      let lehrOut = lehrItem.inspectCount - lehrItem.rejectCount;
      let ceTotal = (lehrOut - bottlesOut);

      // set he loss percent
      let hotEndLoss: number = (heItem.inspectCount - lehrItem.inspectCount) / heItem.inspectCount * 100 || 0.0;
      let heLossIndex = _.findIndex(this.locationLosses, { metricName: 'Hot-End' });
      this.locationLosses[heLossIndex][timeframe + 'Metric'] =
        this.mapNumberToPercent(hotEndLoss);

      // set lehr loss percent
      let lehrLossIndex = _.findIndex(this.locationLosses, { metricName: 'Lehr Loss' });
      this.locationLosses[lehrLossIndex][timeframe + 'Metric'] = 
        this.mapNumberToPercent((lehrItem.rejectCount / heItem.inspectCount) * 100.0);

      // set cold end total
      let ceTotalIndex = _.findIndex(this.locationLosses, { metricName: 'Cold-End Total' });
      this.locationLosses[ceTotalIndex][timeframe + 'Metric'] = 
        this.mapNumberToPercent((ceTotal / heItem.inspectCount) * 100.0);
    }
  }

  mapCeDetailLossesForTimeframe(shopSummaryResults: apsViewModels.ShopSummary, timeframe: string) {
    let shopSummaryTimeframe: apsViewModels.CountSummary[] = shopSummaryResults[timeframe].countSummaries || [];
    let heItem: apsViewModels.CountSummary = this.getHotEnd(shopSummaryTimeframe);
    let lehrItem: apsViewModels.CountSummary = this.getLehrItem(shopSummaryTimeframe);
    let ceItems: apsViewModels.CountSummary[] = this.getColdEndItems(shopSummaryTimeframe);

    // set cold end data
    if (heItem && ceItems && ceItems.length > 0) {
      let countLen = shopSummaryTimeframe.length;
      let bottlesCeIn = ceItems[0].inspectCount;
      let lastItem = shopSummaryTimeframe[countLen - 1];
      let bottlesOut = (lastItem.rejectCount && lastItem.rejectCount > 0.0)
        ? lastItem.inspectCount - lastItem.rejectCount
        : lastItem.inspectCount; 

      // set ce inspection losses
      let coldEndRejects = _.reduce(ceItems, (sum, x) => {
        return sum + x.rejectCount;
      }, 0);
      let ceInspectionIndex = _.findIndex(this.ceDetailLosses, { metricName: 'CE Inspection Losses' });
      this.ceDetailLosses[ceInspectionIndex][timeframe + 'Metric'] =
        this.mapNumberToPercent((coldEndRejects / heItem.inspectCount) * 100.0);

      // set ce inspection delta
      let ceDelta = (bottlesCeIn - bottlesOut) - coldEndRejects;
      let ceDeltaIndex = _.findIndex(this.ceDetailLosses, { metricName: 'CE Inspection Delta' });
      this.ceDetailLosses[ceDeltaIndex][timeframe + 'Metric'] = this.mapNumberToPercent((ceDelta / heItem.inspectCount) * 100.0);
    }
  }

  getColdEndItems(shopSummaryTimeframe: apsViewModels.CountSummary[]): apsViewModels.CountSummary[] {
    let coldEndInspectionItems = _.filter(shopSummaryTimeframe, (cs) => {
      return cs.name !== "HE" && cs.name !== "CUTS" && cs.name !== "LEHR"
        && cs.name !== "EOL" && cs.name !== "TOTL" && cs.name !== "LOut"
        && cs.name !== "CP" && cs.name !== "SPRY" && cs.name !== "STKR";
    });
    return coldEndInspectionItems;
  }

  getLehrItem(shopSummaryTimeframe: apsViewModels.CountSummary[]): apsViewModels.CountSummary {
    let lehrItem = _.findLast(shopSummaryTimeframe, (cs) => {
      return cs.name === "LEHR" || cs.name === "L-L";
    });
    return lehrItem;
  }

  getHotEnd(shopSummaryTimeframe: apsViewModels.CountSummary[]): apsViewModels.CountSummary {
    let hotEndItem = _.findLast(shopSummaryTimeframe, (cs) => {
      return cs.name === "HE" || cs.name === "CUTS";
    });
    return hotEndItem;
  }

  getDefaultLocationLosses() {
    let locationTags = ['Hot-End', 'Lehr Loss', 'Cold-End Total'];
    let locationLosses: MetricOverInterval[] = [];
    _.forEach(locationTags, (lt) => {
      let metricItem: MetricOverInterval = {
        metricName: lt,
        previousProductionDayMetric: '-',
        last24HoursMetric: '-',
        currentHourMetric: '-',
        previousHourMetric: '-',
        currentShiftMetric: '-',
        shiftMinus1Metric: '-',
        shiftMinus2Metric: '-'
      };
      locationLosses.push(metricItem);
    });
    this.locationLosses = locationLosses;
  }

  getDefaultCeDetailLosses() {
    let ceDetailTags = ['CE Inspection Losses', 'CE Inspection Delta'];
    let ceDetailLosses: MetricOverInterval[] = [];
    _.forEach(ceDetailTags, (lt) => {
      let metricItem: MetricOverInterval = {
        metricName: lt,
        previousProductionDayMetric: '-',
        last24HoursMetric: '-',
        currentHourMetric: '-',
        previousHourMetric: '-',
        currentShiftMetric: '-',
        shiftMinus1Metric: '-',
        shiftMinus2Metric: '-'
      };
      ceDetailLosses.push(metricItem);
    });
    this.ceDetailLosses = ceDetailLosses;
  }

  mapInspectionDeviceLosses(shopSummaryResults: apsViewModels.ShopSummary) {
    this.mapInspectionDeviceLossesForTimeframe(shopSummaryResults, 'currentHour');
    this.mapInspectionDeviceLossesForTimeframe(shopSummaryResults, 'previousHour');
    this.mapInspectionDeviceLossesForTimeframe(shopSummaryResults, 'currentShift');
    this.mapInspectionDeviceLossesForTimeframe(shopSummaryResults, 'shiftMinus1');
    this.mapInspectionDeviceLossesForTimeframe(shopSummaryResults, 'shiftMinus2');
    this.mapInspectionDeviceLossesForTimeframe(shopSummaryResults, 'previousProductionDay');
  }

  mapInspectionDeviceLossesForTimeframe(shopSummaryResults: apsViewModels.ShopSummary, timeframe: string) {
    let shopSummaryTimeframe: apsViewModels.CountSummary[] = shopSummaryResults[timeframe].countSummaries || [];
    let ceItems: apsViewModels.CountSummary[] = this.getColdEndItems(shopSummaryTimeframe);

    // initialize if empty
    if (!this.inspectionDeviceLosses || this.inspectionDeviceLosses.length === 0) {
      this.inspectionDeviceLosses = [];
    }

    _.forEach(ceItems, (item) => {
      let index = _.findIndex(this.inspectionDeviceLosses, { metricName: item.name });
      let rejectPercent = (this.usePercentGobs ? item.rejectPercent : this.getRejectInspectPercent(item)) || 0.0;
      let stringPercent = this.mapNumberToPercent(rejectPercent);
      if (index < 0) {
        // if row item doesnt exist then create a new item
        let inspectionLossItem = this.getDefaultPercentLoss(item.name);
        inspectionLossItem[timeframe + 'Metric'] = stringPercent;
        this.inspectionDeviceLosses.push(inspectionLossItem);
      } else {
        // add data if item exist
        this.inspectionDeviceLosses[index][timeframe + 'Metric'] = stringPercent;
      }
    });
  }

  getRejectInspectPercent(item: apsViewModels.CountSummary) {
    if (item.inspectCount > 0 && item.rejectCount > 0) {
      return (item.rejectCount * 100.0) / item.inspectCount;
    }
    return 0.0;
  }

  getDefaultPercentLoss(equipmentName: string) {
    let inspectionDeviceLosses: MetricOverInterval = {
      metricName: equipmentName,
      previousProductionDayMetric: '-',
      last24HoursMetric: '-',
      currentHourMetric: '-',
      previousHourMetric: '-',
      currentShiftMetric: '-',
      shiftMinus1Metric: '-',
      shiftMinus2Metric: '-'
    };
    return inspectionDeviceLosses;
  }

  mapChartDataForTimeframe(shopSummaryResults: apsViewModels.ShopSummary, timeframe: string) {
    let shopSummaryTimeframe: apsViewModels.CountSummary[] = shopSummaryResults[timeframe].countSummaries || [];
    let dataForTimefame = this.getDataForTimeframe(shopSummaryTimeframe);
    this.chartDataHash[timeframe] = dataForTimefame;
  }

  getDataForTimeframe(shopSummaryTimeframe: apsViewModels.CountSummary[]) {
    let rawData = [];
    let sortedData = [];
    let filterData = [];
    let filterName = [];

    _.forEach(shopSummaryTimeframe, (item) => {
      rawData.push({
        name: item.name,
        y: (this.usePercentGobs ? item.rejectPercent : this.getRejectInspectPercent(item))
      });
    });

    filterData = _.filter(rawData, ({ y }) => y > 0.0);
    filterName = _.filter(filterData, ({ name }) => name !== 'HE' && name !== 'CUTS' && name !== 'LEHR');
    sortedData = _.orderBy(filterName, ['y'], ['desc']);
    sortedData.splice(5);

    return sortedData;
  }

  mapNumberToPercent(num: number): string {
    return (num) ? num.toFixed(2) + '%' : '-';
  }
}

export default angular.module('aps.controller.shopSummaryDashboard', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.SHOP_SUMMARY_DASHBOARD,
      url: '/shopSummaryDashboard',
      controller: 'ShopSummaryDashboardCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Shop Summary Dashboard',
        v2Uri: 'aps/dashboard/shop/summary-dashboard'
      }
    });
  })
  .controller('ShopSummaryDashboardCtrl', ShopSummaryDashboardController)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/dashboard/shopSummaryDashboard.controller.ts